import React from "react";
import classnames from "classnames";

import styles from "./Loader.module.scss";

function getAmendedStyle({
  align,
  style = {},
}: {
  align?: "right" | "center" | "left";
  style?: Record<any, any>;
}) {
  switch (align) {
    case "right":
      return {
        ...style,
        justifyContent: "flex-end",
      };
    case "left":
      return {
        ...style,
        justifyContent: "flex-start",
      };
    case "center":
      return {
        ...style,
        justifyContent: "center",
      };
    default:
      return style;
  }
}

interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  show?: boolean;
  size?: number;
  color?: string;
  blurBackground?: boolean;
  align?: "right" | "center" | "left";
  dark?: boolean;
  inline?: boolean;
}

function Loader({
  show = true,
  color = "#4c516a",
  size = 100,
  blurBackground,
  dark,
  inline,
  align,
  style,
  ...rest
}: Readonly<LoaderProps>) {
  const amendedStyle = getAmendedStyle({ style, align });
  const svgColor = dark ? "#FFFFFF" : color;

  if (show) {
    return (
      <div
        data-testid="loading-icon"
        className={classnames(styles.outer_container, {
          [styles.inline!]: inline,
        })}
        {...rest}
        style={amendedStyle}
      >
        {blurBackground && <div className={styles.blur_background} />}
        <div
          className={classnames(styles.svg_container, {
            [styles.inline!]: inline,
          })}
          style={{ height: size, width: size }}
        >
          <svg
            className={styles.circular}
            style={{ height: size, width: size }}
            viewBox="25 25 50 50"
          >
            <circle
              className={styles.circle}
              color={svgColor}
              stroke={svgColor}
              cx="50"
              cy="50"
              r="20"
              fill="none"
              strokeWidth="2.5"
              strokeMiterlimit="10"
            />
          </svg>
        </div>
      </div>
    );
  }
  return null;
}

export default Loader;
